

































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Student, SearchCondition } from '@/modules/student';
import { Account } from '@/modules/me';
import { UserTypes } from '@/enums/userTypes';
import { GradeYears, getGradeYearName } from '@/enums/gradeYears';
import QRCard from '@/components/student/qrCard.vue';
import pdfMake from 'pdfmake/build/pdfmake';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';
import { ElForm } from 'element-ui/types/form';
import DialogWrapper from '@/components/dialogWrapper.vue';
import { ElUpload } from 'element-ui/types/upload';
import Axios from 'axios';
import store from '@/store';
import { CheckBulkCreateStudentsResponse, BulkCreateStudent } from '@/models/checkBulkCreateStudentsResponse';

@Component({
  components: {
    'qr-card': QRCard,
  },
})
export default class StudentBulkInsert extends AvaivaledVue {
  private getGradeYearName = getGradeYearName;

  private page = 1;
  private perPage = 10;
  private sortProp = '';
  private sortDesc = false;

  private csvFile: File | null = null;
  private uploadList: BulkCreateStudent[] = [];
  private creatable = false;

  private loading: boolean = false;

  get countAll(): number {
    if (this.uploadList.length === 0) {
      return 1;
    } else {
      return this.uploadList.length;
    }
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get isAdmin(): boolean {
    return this.userRole === UserTypes.Admin ||
      this.userRole === UserTypes.Owner ||
      this.userRole === UserTypes.AdminTutor;
  }

  get filteringUploadList() {
    const start = this.perPage * (this.page - 1);
    const end = start + this.perPage;
    const sortList = this.uploadList.slice();
    if (this.sortProp) {
      const desc = this.sortDesc ? -1 : 1;
      sortList.sort((a: any, b: any) => {
        if (a[this.sortProp] > b[this.sortProp]) {
        　return 1 * desc;
        } else {
          return -1 * desc;
        }
      });
    }
    return sortList.slice(start, end);
  }

  private getIndexCellClass(row: BulkCreateStudent) {
    if (row.errorMessage) {
      return 'error';
    } else if (row.warningMessage) {
      return 'warning';
    } else {
      return '';
    }
  }

  private formatPostalCode(postalCode: string): string {
    if (!postalCode) {
      return '';
    } else {
      const left = postalCode.substring(0, 3);
      const right = postalCode.substring(3, 7);
      if (!right) {
        return left;
      } else {
        return `${left}-${right}`;
      }
    }
  }

  private beforeRouteEnter(to: any, from: any, next: any) {
    const userRole = store.getters['auth/userType'];
    if (userRole === UserTypes.Admin
      || userRole === UserTypes.Owner
      || userRole === UserTypes.AdminTutor) {
      next();
    } else {
      next({ name: 'StudentList' });
    }
  }

  private deactivated() {
    this.$destroy();
  }

  private async onSelectUploadFile(file: any) {
    this.csvFile = null;
    if (file.name.endsWith('.csv')) {
      this.loading = true;

      const formData = new FormData();
      formData.append('file', file.raw);
      try {
        const res = await Axios.post<CheckBulkCreateStudentsResponse>(
          '/api/Account/CheckBulkCreateStudents',
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' }
          }
        );
        const students = res.data.students;
        students.forEach((student) => {
          if (typeof student.birthDay === 'string') {
            if ((student.birthDay as string).endsWith('Z')) {
              student.birthDay = new Date(student.birthDay);
            } else {
              student.birthDay = new Date(student.birthDay + 'Z');
            }
          }
        });
        const len = students.length.toString().length;
        const paddingValue = Array(len).join('0');
        let num = 1;
        this.uploadList = students.map((student) => Object.assign(student, {
            userId: student.userId ? student.userId : `自動採番${(paddingValue + num++).slice(-len)}`,
        }));
        this.creatable = res.data.creatable;
        this.csvFile = file;
      } catch (error) {
        this.uploadList = [];
        this.creatable = false;
        this.$notify.error({
          title: 'エラー',
          message: (error.response && error.response.data) || 'CSVファイルの読み込みに失敗しました',
          position: 'bottom-right'
        });
      }

      this.loading = false;
    }
  }

  private async onCancel() {
    this.csvFile = null;
    this.uploadList = [];
  }

  private async onRegist() {
    if (!this.csvFile) { return; }

    try {
      await this.$confirm('生徒を一括登録します。よろしいですか？', '生徒一括登録', {
        confirmButtonText: '一括登録',
        cancelButtonText: 'キャンセル',
        type: 'info'
      });
    } catch (error) {
      return;
    }

    this.loading = true;

    window.onbeforeunload = (e: any) => {
      e.returnValue = '一括登録は継続される為、案内資料をダウンロードできなくなります。よろしいですか？';
    };

    const formData = new FormData();
    formData.append('file', (this.csvFile as any).raw);
    try {
      const response = await Axios.post(
        '/api/Account/BulkCreateStudents',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          responseType: 'blob'
        }
      );

      let fileName = '';
      const disposition = response.headers['content-disposition'];
      if (disposition && disposition.indexOf('attachment') !== -1) {
        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
        if (matches != null && matches[1]) {
          fileName = decodeURI(matches[1].replace(/['"]/g, ''));
        }
      }

      if (fileName === '') {
        fileName = '案内資料.zip';
      }

      if (!(window.navigator as any).msSaveOrOpenBlob) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        const url = (window.navigator as any).msSaveOrOpenBlob(new Blob([response.data]), fileName);
      }

      this.$router.push({ name: 'StudentList' });
    } catch (error) {
      this.$notify.error({
        title: 'エラー',
        message: (error.response && error.response.data) || '生徒の一括登録に失敗しました',
        position: 'bottom-right'
      });
    }

    window.onbeforeunload = null;
    this.loading = false;
  }

  private getRowNumber(index: number) {
    return this.perPage * (this.page - 1) + index + 1;
  }

  private onChangeSort( {prop, order}: any ) {
    if (!prop) {
      this.sortProp = '';
      this.sortDesc = false;
    } else {
      this.sortProp = prop;
      this.sortDesc = (order === 'descending');
    }
  }

  private async onDownloadCSVTemplate() {
    try {
      const response = await Axios.get(
        '/api/Account/DownloadBulkCreateStudentsTemplate',
        {
          responseType: 'blob'
        }
      );

      let fileName = '';
      const disposition = response.headers['content-disposition'];
      if (disposition && disposition.indexOf('attachment') !== -1) {
        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
        if (matches != null && matches[1]) {
          fileName = decodeURI(matches[1].replace(/['"]/g, ''));
        }
      }

      if (fileName === '') {
        fileName = '生徒一括登録テンプレート.csv';
      }

      if (!(window.navigator as any).msSaveOrOpenBlob) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        const url = (window.navigator as any).msSaveOrOpenBlob(new Blob([response.data]), fileName);
      }
    } catch (error) {
      this.$notify.error({
        title: 'エラー',
        message: (error.response && error.response.data) || 'テンプレートのダウンロードに失敗しました',
        position: 'bottom-right'
      });
    }
  }
}
